import angular from 'angular';
import constants from 'app/constants';
import {
  loaderService,
  ssDialogService,
  vmSharedModelService,
} from 'app/services';
import { alerts } from 'app/components/global';
import editVendorDialog from './dialog.editVendorDialog';
import vendor from './vendor';
import controller from './select-vendor-resources-dialog.controller';
import template from './select-vendor-resources-dialog.html';


class dialogService {
  getOptions($event, {
    vendors, assessmentId, vendorResources
  }) {
    return {
      controller,
      controllerAs: 'selectVendorResourcesDialogVM',
      locals: {
        vendors,
        assessmentId,
        vendorResources
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.bcp.selectVendorResourcesDialog', [
  vendor,
  alerts,
  constants,
  loaderService,
  ssDialogService,
  editVendorDialog,
  vmSharedModelService,
])
  .service('selectVendorResourcesDialog', dialogService)
  .name;
